import React from "react";
import { Image } from "../interfaces/common";
import { isYoutubeURL } from "../../utils/isYoutubeURL";
import ReactPlayer from "react-player";

interface Props extends Image {
  ImageProvider?: any;
  className?: string;
  id?: string;
  objectFit?: "cover" | "contain";
  height?: string;
  width?: string;
}

const Image = ({
  className,
  desktop,
  alt,
  id,
  ImageProvider,
  objectFit = "cover",
  width,
  height,
}: Props) => {
  if (!desktop) {
    return <></>;
  }
  if (isYoutubeURL(desktop)) {
    return (
      <div id={`${id}ContainerVideo`} className={className}>
        <ReactPlayer
          id={`${id}Video`}
          width="100%"
          height="auto"
          style={{ aspectRatio: "16 / 9" }}
          className="w-full aspect-video"
          url={desktop}
        />
      </div>
    );
  }

  if (ImageProvider) {
    return (
      <ImageProvider
        id={`${id}Image`}
        src={desktop}
        alt={alt}
        width={0}
        height={0}
        sizes="100vw"
        style={{ width, height }}
        objectFit={objectFit}
        className={`${className}`}
      />
    );
  }
  return (
    <img id={`${id}Image`} src={desktop} alt={alt} className={`${className}`} />
  );
};

export default Image;
